import * as types from "../constants/nfc_card_constants";

const initialState = {
  data: [],
  card: null,
  nfcCardError: null,
};

const nfcCardReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.GET_USER_NFC_CARDS_SUCCESS:
      return {
        ...state,
        data: payload ? payload.cards : [],
        nfcCardError: null,
      };

    case types.APPLY_NFC_CARD_SUCCESS:
    case types.UPDATE_NFC_CARD_BANK_DETAILS_SUCCESS:
      return {
        ...state,
        card: payload ? payload.card : null,
        nfcCardError: null,
      };

    case types.UPLOAD_NFC_CARD_PHOTO_SUCCESS:
      return {
        ...state,
        card: payload ? payload.card : null,
        nfcCardError: null,
      };

    case types.NFC_CARD_PAYMENT_SUCCESS:
      return {
        ...state,
        card: payload ? payload.card : null,
        nfcCardError: null,
      };

    case types.GET_USER_NFC_CARDS_FAILURE:
    case types.APPLY_NFC_CARD_FAILURE:
    case types.UPDATE_NFC_CARD_BANK_DETAILS_FAILURE:
    case types.UPLOAD_NFC_CARD_PHOTO_FAILURE:
    case types.NFC_CARD_PAYMENT_FAILURE:
      return { ...state, nfcCardError: payload ? payload : null };

    default:
      return state;
  }
};

export default nfcCardReducer;
